export default __webpack_public_path__ + "static/media/top_banner_bg1.58f8080e.jpg";